import { QualityLevel } from "./types";

export const DefaultQuality: QualityLevel = {
	index: -1,
	label: 'Auto',
	internal: 'auto'
};